import { useTranslation } from 'react-i18next';

import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { Cancel } from '@/components/icons/Cancel';
import { Pencil } from '@/components/icons/Pencil';
import { Reactivate } from '@/components/icons/Reactivate';
import { TransferIcon } from '@/components/icons/TransferIcon';
import { Trash } from '@/components/icons/Trash';

type TMemberActionProps = {
  action: TMemberAction;
  execute: (action: TMemberAction) => void;
};

export type TMemberAction =
  | 'cancel'
  | 'edit'
  | 'suspend'
  | 'reactivate'
  | 'remove'
  | 'transferOwnership';

export const MemberAction = ({ action, execute }: TMemberActionProps) => {
  const { t } = useTranslation();

  switch (action) {
    case 'cancel':
      return (
        <MenuItem onClick={() => execute('cancel')}>
          <ListItemIcon>
            <Cancel color="error" />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ color: 'error' }}
            primary={t('members.cancelInvite')}
          />
        </MenuItem>
      );

    case 'edit':
      return (
        <MenuItem onClick={() => execute('edit')}>
          <ListItemIcon>
            <Pencil color="text.primary" />
          </ListItemIcon>
          <ListItemText primary={t('common.edit')} />
        </MenuItem>
      );

    case 'suspend':
      return (
        <MenuItem onClick={() => execute('suspend')}>
          <ListItemIcon>
            <Cancel color="error" />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ color: 'error' }}
            primary={t('members.suspendUser')}
          />
        </MenuItem>
      );

    case 'reactivate':
      return (
        <MenuItem onClick={() => execute('reactivate')}>
          <ListItemIcon>
            <Reactivate color="text.primary" />
          </ListItemIcon>
          <ListItemText primary={t('members.reactivateUser')} />
        </MenuItem>
      );

    case 'remove':
      return (
        <MenuItem onClick={() => execute('remove')}>
          <ListItemIcon>
            <Trash color="error" />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ color: 'error' }}
            primary={t('members.removeUser')}
          />
        </MenuItem>
      );

    case 'transferOwnership':
      return (
        <MenuItem onClick={() => execute('transferOwnership')}>
          <ListItemIcon>
            <TransferIcon color="text.primary" />
          </ListItemIcon>
          <ListItemText primary={t('members.transferOwnershipMessage')} />
        </MenuItem>
      );
  }
};
